import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import './css/VideoModal.css'

class VideoModal extends Component {
    constructor(params) {
        super(params)
        this.handleClose = this.handleClose.bind(this)
        this.handleShow = this.handleShow.bind(this)
        this.correctLink = this.handleShow.bind(this)
        this.state = {
            modalShow: false,
            src: this.props.videoURL.replace('/watch?v=', '/embed/') + '?rel=0',
            imgSrc: '/videoIcon.png',

        }
    }
    handleClose() {
        this.setState({ modalShow: false })
    }

    handleShow() {
        this.setState({ modalShow: true })
    }

    render() {
        return (
            <span className='modalContainer'>
                <Button className='btnVideoModal' onClick={() => this.handleShow()}><img alt='howToVideo' className='videoIcon' src={this.state.imgSrc} /></Button>
                <Modal
                    dialogClassName='videoModal'
                    aria-labelledby='contained-modal-title-sm'
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                >
                    <Modal.Header className='modalHeader' closeButton></Modal.Header>
                    <Modal.Body className='modalBody'>
                        <iframe className='videoBox' title={this.props.videoTitle} src={this.state.src} allowFullScreen></iframe>
                    </Modal.Body>
                    <Modal.Footer className='modalFooter' ></Modal.Footer>
                </Modal>
            </span>
        )
    }
}

VideoModal.propTypes = {
    videoURL: PropTypes.string.isRequired,
    videoTitle: PropTypes.string.isRequired,
}

export default VideoModal


// WEBPACK FOOTER //
// ./src/components/VideoModal.js